class FeedbackForm {
  constructor() {
    this.handleCheckbox()
  }

  handleCheckbox() {
    let emailCheck = document.getElementById("CacheableForm_FeedbackForm_ReplyToMe")
    let emailField = document.getElementById("CacheableForm_FeedbackForm_ReplyEmail")
    if (emailField) {
      emailField.disabled = true

      emailCheck.addEventListener("change", event => {
        if (event.currentTarget.checked) {
          emailField.disabled = false
          emailField.required = true
        } else {
          emailField.disabled = true
          emailField.required = false
        }
      })
    }
  }
}

export default FeedbackForm
